import React, { useState } from "react";
import { CircularProgress, Grid, IconButton } from "@mui/material";
import { useIntl } from "react-intl";
import { Modal } from "@packsize/components";
import HistoryOutlined from "@mui/icons-material/HistoryOutlined";

import { type CartonPropertyGroup } from "@/schemas/carton-property-group";
import { DiffView } from "@/components/diff-view";
import { useCartonPropertyGroupConfigurationHistory } from "@/hooks/carton-property-groups";

interface CartonPropertyGroupButtonProps {
	readonly cartonPropertyGroup: CartonPropertyGroup;
}

export const CartonPropertyGroupHistoryButton: React.FC<CartonPropertyGroupButtonProps> = ({ cartonPropertyGroup }) => {
	const intl = useIntl();
	const [isOpen, setIsOpen] = useState<boolean>(false);
	const historyData = useCartonPropertyGroupConfigurationHistory(cartonPropertyGroup.id, isOpen);

	const loadingHistoryData = historyData.isLoading || historyData.isFetchedAfterMount === false;

	return (
		<>
			<Modal
				onClose={() => setIsOpen(false)}
				title={intl.formatMessage(
					{
						id: "Carton Property Group History: {alias}",
						defaultMessage: "Carton Property Group History: {alias}",
					},
					{ alias: cartonPropertyGroup.alias },
				)}
				open={isOpen}
				size="xl"
				slotProps={{
					contentContainer: {
						sx: {
							p: 0,
							overflowY: "scroll",
						},
					},
				}}
			>
				{loadingHistoryData === true && (
					<Grid container justifyContent="center" alignItems="center" sx={{ minHeight: 200 }}>
						<CircularProgress color="info" data-testid="carton-property-group-history-button__progress__loading" />
					</Grid>
				)}
				{loadingHistoryData === false && <DiffView data={historyData.data} autoExpand={false} />}
			</Modal>
			<IconButton
				onClick={() => setIsOpen(true)}
				data-testid="carton-property-group-configuration-history-button__button__open-modal"
				data-pendoid="carton-property-groups__button__history"
			>
				<HistoryOutlined />
			</IconButton>
		</>
	);
};
